export const capitalizeFirstChar = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const extractMajorVer = (version: string): string | undefined =>
  version.split(".").shift();
